import "core-js/modules/es.object.assign.js";
var createEventObj = function createEventObj(data) {
  var eventObj = {
    event: "GAevent"
  };
  if (data.event_location) eventObj.event_location = data.event_location;
  if (data.event_name) eventObj.event_name = data.event_name;
  if (window["_referral_url"]) eventObj.referral_url = window["_referral_url"];
  return eventObj;
};
/*  GA4 EVENT HANDLERS  */
var avmValuationCompletedGaEvent = function avmValuationCompletedGaEvent() {
  window.dataLayer.push(createEventObj({
    event_location: "AVM_Step3",
    event_name: "avm_valuation_completed"
  }));
};
var avmStep2ReachedGaEvent = function avmStep2ReachedGaEvent() {
  window.dataLayer.push(createEventObj({
    event_location: "AVM_Step2",
    event_name: "avm_step1_completed"
  }));
};
var trendWidgetEmbedGaEvent = function trendWidgetEmbedGaEvent(customParameters) {
  window.dataLayer.push(Object.assign(Object.assign({}, createEventObj({
    event_location: "Trend Widget",
    event_name: "widget_trend_embed"
  })), customParameters));
};
var avmStep2ErrorGaEvent = function avmStep2ErrorGaEvent() {
  window.dataLayer.push(createEventObj({
    event_location: "AVM_Step2",
    event_name: "avm_step2_error"
  }));
};
/* ---  GA4 EVENT HANDLERS ---- */
/* MESSAGE EVENT HANDLERS */
var avmValuationCompletedMessageEvent = function avmValuationCompletedMessageEvent() {
  var _a;
  (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(createEventObj({
    event_location: "AVM_Step3",
    event_name: "avm_valuation_completed"
  }), "*");
};
var avmStep2ReachedMessageEvent = function avmStep2ReachedMessageEvent() {
  var _a;
  (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(createEventObj({
    event_location: "AVM_Step2",
    event_name: "avm_step1_completed"
  }), "*");
};
var avmStep2ErrorMessageEvent = function avmStep2ErrorMessageEvent() {
  var _a;
  (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(createEventObj({
    event_location: "AVM_Step2",
    event_name: "avm_step2_error"
  }), "*");
};
var trendWidgetEmbedMessageEvent = function trendWidgetEmbedMessageEvent(customParameters) {
  var _a;
  (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(Object.assign(Object.assign({}, createEventObj({
    event_location: "Trend Widget",
    event_name: "widget_trend_embed"
  })), customParameters), "*");
};
var trendWidgetInteractionMessageEvent = function trendWidgetInteractionMessageEvent(customParameters) {
  var _a;
  (_a = window.top) === null || _a === void 0 ? void 0 : _a.postMessage(Object.assign(Object.assign({}, createEventObj({
    event_location: "Trend Widget",
    event_name: "widget_trend_interaction"
  })), customParameters), "*");
};
var trendWidgetInteractionGaEvent = function trendWidgetInteractionGaEvent(customParameters) {
  window.dataLayer.push(Object.assign(Object.assign({}, createEventObj({
    event_location: "Trend Widget",
    event_name: "widget_trend_interaction"
  })), customParameters));
};
/* ---  MESSAGE EVENT HANDLERS ---- */
var GAEventsHandler = {
  AVM_VALUATION_COMPLETED: avmValuationCompletedGaEvent,
  AVM_STEP1_COMPLETED: avmStep2ReachedGaEvent,
  AVM_STEP2_ERROR: avmStep2ErrorGaEvent,
  TREND_WIDGET_EMBEDDED: trendWidgetEmbedGaEvent,
  TREND_WIDGET_INTERACTION: trendWidgetInteractionGaEvent
};
var MessageEventsHandler = {
  AVM_VALUATION_COMPLETED: avmValuationCompletedMessageEvent,
  AVM_STEP1_COMPLETED: avmStep2ReachedMessageEvent,
  AVM_STEP2_ERROR: avmStep2ErrorMessageEvent,
  TREND_WIDGET_EMBEDDED: trendWidgetEmbedMessageEvent,
  TREND_WIDGET_INTERACTION: trendWidgetInteractionMessageEvent
};
export var sendGAevent = function sendGAevent(eventName, data) {
  var handler = GAEventsHandler[eventName];
  handler && handler(data);
};
export var sendMessageEvent = function sendMessageEvent(eventName, data) {
  var messageHandler = MessageEventsHandler[eventName];
  messageHandler && messageHandler(data);
};